import { LegalCoverSlide } from "./slides/LegalCoverSlide";
import { LegalAboutSlide } from "./slides/LegalAboutSlide";
import { LegalProblemSlide } from "./slides/LegalProblemSlide";
import { LegalShiftSlide } from "./slides/LegalShiftSlide";
import { LegalCapabilitiesSlide } from "./slides/LegalCapabilitiesSlide";
import { LegalHowItWorksSlide } from "./slides/LegalHowItWorksSlide";
import { LegalProvenSlide } from "./slides/LegalProvenSlide";
import { LegalPracticeAreasSlide } from "./slides/LegalPracticeAreasSlide";
import { LegalSecuritySlide } from "./slides/LegalSecuritySlide";
import { LegalCTASlide } from "./slides/LegalCTASlide";

export const legalSlideComponents = [
  LegalCoverSlide,
  LegalAboutSlide,
  LegalProblemSlide,
  LegalShiftSlide,
  LegalCapabilitiesSlide,
  LegalHowItWorksSlide,
  LegalProvenSlide,
  LegalPracticeAreasSlide,
  LegalSecuritySlide,
  LegalCTASlide,
];
